import { Dispatch, SetStateAction, useState } from "react";

import { useCumPlusForecast } from "hooks";

// EVA-6412 RESHAPE (T021) — fixes P5. Deletes the three mirror refs
// (checkedGlobalForecastsRef, specialForecastFoldersRef, syncWellsRef); the
// underlying Redux/Zustand reads they mirrored now live in
// useGroupByFilterDependencies (checkedGlobalForecasts/specialForecastFolders/
// syncWells) and consumers (useBinSettingsController, useLegendController)
// read them fresh from `deps` instead of a ref. This hook now owns only the
// small UI toggle state it always genuinely owned.
export interface ForecastFocusControllerResult {
  isForecastToggleOn: boolean;
  setIsForecastToggleOn: Dispatch<SetStateAction<boolean>>;
  selectedForecastFolder: string;
  setSelectedForecastFolder: Dispatch<SetStateAction<string>>;
  setCumPlusForecast: (value: boolean) => void;
}

export const useForecastFocusController = (): ForecastFocusControllerResult => {
  const [isForecastToggleOn, setIsForecastToggleOn] = useState(false);
  const [selectedForecastFolder, setSelectedForecastFolder] = useState("");
  const [, setCumPlusForecast] = useCumPlusForecast();

  return {
    isForecastToggleOn,
    setIsForecastToggleOn,
    selectedForecastFolder,
    setSelectedForecastFolder,
    setCumPlusForecast
  };
};
